import { MetaConversation } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';

import { actions } from '../../../telephony/actions/telephony';
import {
  OwnProps,
  TelephonyTopbarButton,
} from '../components/telephonyTopbarButton';

const mapStateToProps = (state: RootReducerStateT) => {
  let canMakeOutBoundCall = true;
  let isInternalCall = false;
  let activePhoneMetaConversation: null | MetaConversation = null;

  try {
    // Find active phone calls.
    // Check it the agent presence is ready to make a new call.
    // Means that the agent does not have any active phone conversations in presence status load.
    const foundSpeakLoad =
      state.presence.presence.presence_status.load_descriptions.find(
        ({ media_type, load_type, conversation_channel, conversation }) =>
          media_type === 'speak' &&
          (conversation_channel === 'pstnphone' ||
            (conversation?.initial_channel === 'callback' &&
              conversation?.is_callback_consumed === false)) &&
          load_type !== 'acw' &&
          load_type !== 'nonlive',
      );

    // We already have a active phone conversation in our load description. We cannot start a new one.
    if (foundSpeakLoad) {
      canMakeOutBoundCall = false;
      isInternalCall =
        foundSpeakLoad.load_type !== undefined &&
        foundSpeakLoad.load_type === 'internalwork'
          ? true
          : false;
    }
    // Twilio client is not ready yet.
    if (state.telephony.isReady === false) {
      canMakeOutBoundCall = false;
    }
    // This microphone is blocked.
    if (state.telephony.isMicrophoneBlocked) {
      canMakeOutBoundCall = false;
    }

    // Check if we are listening in on a another agents conversation.
    if (state.telephony.currentCall && state.telephony.currentCall.csid) {
      canMakeOutBoundCall = false;
    }

    // check that presence tells us that we have an active phone conversation
    // If true -> then look for the active phone conversation in conversations.
    if (foundSpeakLoad) {
      for (const metaConversation of state.conversations.metaConversations) {
        if (
          metaConversation.conversation.is_closed === false &&
          metaConversation.isAssignedToMe === true &&
          (metaConversation.conversation.initial_channel === 'pstnphone' ||
            metaConversation.conversation.initial_channel === 'callback')
        ) {
          activePhoneMetaConversation = metaConversation;
          break;
        }
      }
    }
  } catch (exception) {
    console.error(exception);
    canMakeOutBoundCall = true;
  }

  return {
    isInternalCall: isInternalCall,
    canMakeOutBoundCall: canMakeOutBoundCall,
    isTelephonyDropdownOpen: state.telephony.ui.isTelephonyDropdownOpen,
    users: state.telephony.users,
    activePhoneMetaConversation: activePhoneMetaConversation,
    defaultNumber:
      state.settings.organization.organization.default_outbound_number,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    telephonyOpenDropdown: () => dispatch(actions.telephonyOpenDropdown()),
    telephonyCloseDropdown: () => dispatch(actions.telephonyCloseDropdown()),
  };
};

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export default connect<StateProps, DispatchProps, OwnProps, RootReducerStateT>(
  mapStateToProps,
  mapDispatchToProps,
)(TelephonyTopbarButton);
